var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F5F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 25.1999H12.7C12.1477 25.1999 11.7 24.7522 11.7 24.1999V10.8999C11.7 10.3476 12.1477 9.8999 12.7 9.8999H21.5C22.0522 9.8999 22.5 10.3476 22.5 10.8999V17.0999",
    stroke: "#008C15",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1 18H19.35V19.8H17.1V18ZM20.25 18H22.95V19.8H20.25V18ZM23.85 18H26.1V19.8H23.85V18ZM17.1 23.025V20.775H18.9V23.025H17.1ZM26.1 20.775V23.025H24.3V20.775H26.1ZM17.1 26.025V23.775H18.9V26.025H17.1ZM26.1 23.775V26.025H24.3V23.775H26.1ZM17.1 27H19.35V28.8H17.1V27ZM26.1 27V28.8H23.85V27H26.1ZM22.95 28.8H20.25V27H22.95V28.8Z",
    fill: "#008C15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyContract);
export default __webpack_public_path__ + "static/media/CopyContract.7f978a606a1914642b41b3398295335c.svg";
export { ForwardRef as ReactComponent };